import React, { createContext, useContext } from "react";
import config from "../config.json";

const ConfigContext = createContext();

export const useAppConfig = () => useContext(ConfigContext);

export const AppConfigProvider = ({ children }) => {
  const environment = process.env.REACT_APP_MODE || "development";

  const appConfig = {
    ...config.common,
    ...config[environment],
  };

  return (
    <ConfigContext.Provider value={appConfig}>
      {children}
    </ConfigContext.Provider>
  );
};
